import { useUserInfo } from "@next-platform/client-common-core";

import { USER_ROLES } from "../../../constants";

export default function getUserPlan() {
  const { role } = useUserInfo();
  const isUserFree = role === USER_ROLES.FREE;
  const isUserBasic = role === USER_ROLES.BASIC;
  const isUserMinimal = role === USER_ROLES.MINIMAL;
  const isUserPremium = role === USER_ROLES.PREMIUM;
  const hasUserSubscribedPlan = isUserBasic || isUserMinimal || isUserPremium;

  return { isUserFree, isUserBasic, isUserMinimal, isUserPremium, hasUserSubscribedPlan };
}
